import {actionNames} from 'constants/index';
const actions ={};

actions.MODULO_FALLECIDOS_SET_STEPPER =(state)=>{
    return { type:actionNames.MODULO_FALLECIDOS_SET_STEPPER, state};
}
actions.MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO =(state)=>{
    return { type:actionNames.MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO, state};
}
export default actions;